import { render } from "./registration-type-field.vue?vue&type=template&id=391186b4&ts=true"
import script from "./registration-type-field.vue?vue&type=script&lang=ts"
export * from "./registration-type-field.vue?vue&type=script&lang=ts"

import "./registration-type-field.vue?vue&type=style&index=0&id=391186b4&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__